import { withTranslation } from "react-i18next"
import { Button, InputNumber, } from "antd"
import Slider from "react-slick";
import { useState } from "react";

/**
 * PictureSelection
 * @param {*} props 
 * @returns 
 */
const PictureSelection = (props) => {
  const [amount, setAmount] = useState(null)

  const settings = {
    className: "center",
    centerMode: false,
    infinite: false,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500
  };

  return (
    <div>
      <div className="slider-container" style={{ marginTop: 10 }}>
        <Slider {...settings}>
          {
            props.pictures.map((pic) => (
              <div onClick={() => props.setSelectedPicture(pic)}>
                <img 
                  alt="giftcard" 
                  src={`${process.env.REACT_APP_S3_FILES_URL}${pic.file}`}  
                  style={{ cursor: 'pointer', display: 'block', width: 110, height: 70, margin: 5, borderRadius: 5, border: props.selectedPicture && props.selectedPicture._id === pic._id ? '3px solid #0097a7' : ''  }}
                />
              </div>
            ))
          }
        </Slider>
      </div>

      <div style={{ borderBottom: '2px solid #e5e7eb' }} />
      <div style={{ padding: 5 }}>
        {
          props.categories.map((category) => (
            <div style={{ color: '#555', fontSize: 16, padding: 10, borderBottom: '2px solid #e5e7eb' }} key={`cat-${category._id}`}>
              <div style={{ display: 'flex' }}>
                <div style={{ fontSize: 15, fontWeight: 'bold'}}>{category.title}</div>
                <div style={{ marginLeft: 'auto', fontSize: 16, marginRight: 10, fontWeight: '500', marginTop: 3, color: '#555', }}>
                  {category.amount} €
                </div>
                <div>
                  <Button type="primary" onClick={() => props.handleOnSelectCategory(category)}>Acheter</Button>
                </div>
              </div>
              <div style={{ color: '#6b7280', marginTop: 5, fontSize: 13 }}>
                {category.description}
              </div>
            </div>
          ))
        }
        
        <div style={{ color: '#555', fontSize: 16, padding: 10, borderBottom: '2px solid #e5e7eb' }}>
          <div style={{ display: 'flex' }}>
            <div style={{ fontSize: 15, fontWeight: 'bold'}}>Bon d'achat</div>

            <div style={{ marginLeft: 'auto', fontSize: 16, fontWeight: '500', marginTop: 3, color: '#555', }}>
              <div style={{ display: 'flex' }}>
                <InputNumber
                  style={{
                    width: 100,
                    borderRadius: '4px 0 0 4px'
                  }}
                  placeholder="0.00€"
                  onChange={(val) => setAmount(val)}
                  min={10}
                />
                <Button type="primary" style={{ borderRadius: '0 4px 4px 0'}} onClick={() => props.handleOnSubmitAmount(amount)}>Acheter</Button>
              </div>
            
            </div>
          </div>
          <div style={{ color: '#6b7280', marginTop: 5, fontSize: 13 }}>
            Bon d'achat de la valeur que vous décidez, a dépenser chez Ikomiris
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(PictureSelection);